import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  templateUrl: 'icon-button.component.html',
  styleUrls: ['icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  @Input() icon: string = 'chevron-down';
  @Input() flip: boolean = false;

  constructor() {}
}
